import styled from 'styled-components';
import { MatrixCellElement as TableCell, MatrixHeaderCellElement as TableHeaderCell } from '@mews/b2b-ui';
import { getSpacingToken, getTextTokenPreset, getToken } from '@optimus-web/core';

export const TableWrapperElement = styled.div.attrs({ className: 'table-responsive-wrapper' })``;

export const TableContainerElement = styled.div`
    & > *:not(:last-child) {
        margin-bottom: ${getSpacingToken('200')}px;
    }
`;

export const TableElement = styled.table.attrs({ className: 'table table-responsive table-condensed' })``;

export const TableHeaderCellElement = styled(TableHeaderCell)`
    ${getTextTokenPreset('bodySmallStrong')};
    padding: 5px;
    vertical-align: bottom;
    height: auto;
    border-bottom: 1px solid ${getToken('borderStaticSecondary')};
`;

export const TableCellElement = styled(TableCell)`
    ${getTextTokenPreset('bodyMediumStrong')};
    padding: 5px;
    height: auto;
    border-bottom: 1px solid ${getToken('borderStaticSecondary')};
`;
